<header class="header header--basic align-center">

  <svg class="header__logo d-inline"
       viewBox="0 0 111 39.96">
    <use xlink:href="#ab-logo"></use>
  </svg>

</header>

<div class="content content--narrow vert-0500 center">

  <h1 class="h2">
    Page Not Found
  </h1>
  <p class="large vert-0100">
  The link you clicked may be broken or the page may have been removed.
  </p>
  <p class="caps vert-0075">
    <strong>Visit the <a href="/" class="link">homepage</a> or <a href="/feedback" class="link">contact us</a> about the problem</strong>
  </p>

</div>
